import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { OpportunityStatusView } from '@api-proxies';
import { OpportunityStatusService } from '@http/clients/opportunity-status.service';
import { GenericDropdownMultiselectComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../base/form-editor-base';

@Component({
    selector: 'app-statuses-form-editor',
    templateUrl: './statuses-form-editor.component.html',
    styleUrls: ['./statuses-form-editor.component.scss'],
    providers: [createValueAccessorProvider(StatusesFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class StatusesFormEditorComponent extends FormEditorBase<OpportunityStatusView[]> implements OnInit {
    value = input<OpportunityStatusView[]>();
    readonly = input<boolean>(false);
    placeholderText = input<string>('Select Statuses');

    private readonly opportunityStatusService = inject(OpportunityStatusService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.loadStatuses();
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): OpportunityStatusView[] {
        return this.selectedItems() || [];
    }

    protected override mapValueToSelectedItems(value: OpportunityStatusView[]): any[] {
        return value || [];
    }

    private async loadStatuses(): Promise<void> {
        const statuses = await this.opportunityStatusService.getAll();
        this.items.set(statuses);
    }
}
